export const repeatStringXTimes = (value, repeatXTimes, joinWith = ' ') => {
  return Array.from({ length: repeatXTimes })
    .map(() => value)
    .join(joinWith)
}
